import { connect } from 'react-redux';
import ContinueConfirmation from './ContinueConfirmation';
import { confirmContinue, clearSession } from '../../actions/session';

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({
  confirmContinue() {
    dispatch(confirmContinue());
  },
  logout: dispatch(clearSession)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContinueConfirmation);



// WEBPACK FOOTER //
// ./src/containers/ContinueConfirmation/index.js